<template>
  <div class="StatisticalGraph">
    <div style="width: 100%; height: 200px" v-bind:id="id"></div>
  </div>
</template>

<script>
import { getUUID } from '../../../../utils/util'
import chartResize from '@/mixin/chart-resize'
let unwatch
export default {
  mixins: [chartResize],
  name: 'NestedRing',
  components: {},
  data() {
    return {
      id: getUUID(),
    }
  },
  props: {
    data: {
      type: Object,
    },
    // eslint-disable-next-line vue/require-default-prop
    total: {
      type: Number,
    },
  },
  myChart: null,
  methods: {
    set(data) {
      // let data = [40,20,30,40,55],
      // let data2 = [88,43,11,74,150]
      var option
      option = {
        tooltip: {
          trigger: 'axis',

          formatter: function (params) {
            console.log(params)
            var result = ''
            result +=
              '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:rgb(52,136,237);"></span>' +
              params[1].name +
              '<br>' +
              params[0].seriesName +
              '年' +
              ': ' +
              params[0].value +
              '<br>' +
              params[1].seriesName +
              '年' +
              ': ' +
              params[1].value

            return result
          },
        },
        legend: {
          right: '8%',
          top: '3%',
        },
        grid: data.grid,
        color: data.color,
        //   ? data.title
        //   : {
        //       subtext: ' m³'
        //     }
        xAxis: {
          type: 'category',
          data: data.xdata,
          // axisLabel: {
          //   // eslint-disable-next-line eqeqeq
          //   rotate: data.rotate == 0,
          //   margin: 8,
          //   formatter: function (params) {
          //     var val = ''
          //     if (params.length > 3) {
          //       val = params.substr(0, 3) + '..'
          //       return val
          //     } else {
          //       return params
          //     }
          //   }
          // }
        },
        yAxis: {
          type: 'value',
          name: '个',
          axisLabel: {
            formatter: '{value}',
          },
        },
        series: data.series,
      }

      // option && myChart.setOption(option)

      this.myChart.setOption(option)
      // window.addEventListener('resize', function() {
      //   this.myChart.resize()
      // })
    },
    drawRingGraph(id) {
      let _this = this
      // eslint-disable-next-line no-undef
      this.myChart = echarts.init(document.getElementById(id))

      unwatch = this.$watch(
        'data',
        function (newvalue, oldvalue) {
          if (newvalue) {
            console.log(newvalue, 'newvalue')
            this.set(newvalue)
          }
        },
        { deep: true, immediate: true }
      )
    },
  },
  mounted() {
    this.drawRingGraph(this.id)
  },
  created() {},
  beforeDestroy() {
    if (unwatch) {
      unwatch()
      unwatch = null
    }
    if (!this.myChart) {
      this.myChart.dispose()
      this.myChart = null
    }
  },
}
</script>

<style lang="less" scoped>
.StatisticalGraph {
  width: 100%;
  height: 100%;
}
</style>
